import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-bold" }

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import type { Payroll, Employee } from '@/types';
    import { Button } from '@/components/ui/button';
    import { ChevronRight } from 'lucide-vue-next';
    import { router } from '@inertiajs/vue3';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollApprovalAlertDialog',
  props: {
    payroll: {},
    employees: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const { mutate, isPending } = useMutation({
        mutationFn: () =>
            axios.post(
                route('v2.salary.payrolls.approve', {
                    payrollId: props.payroll.id,
                }),
            ),
        onSuccess: (data) => {
            toast.success(data.data.success || t('forms.general.success'));
            router.reload();
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.error || t('forms.system_error'));
        },
    });

    const employeesWithoutStatus = computed(() => {
        return props.employees.filter((employee) => !employee.status);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost_primary",
            size: "xs",
            width: "narrow"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.approve')) + " ", 1),
              _createVNode(_unref(ChevronRight), { class: "text-primary" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.approve')), 1)
                ]),
                _: 1
              }),
              (!!employeesWithoutStatus.value.length)
                ? (_openBlock(), _createBlock(_unref(AlertDialogDescription), {
                    key: 0,
                    class: "flex flex-col gap-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('payrolls.changes.confirm_1')) + " ", 1),
                      _createElementVNode("span", _hoisted_1, _toDisplayString(employeesWithoutStatus.value.map((employee) => employee.name).join(', ')), 1),
                      _createTextVNode(" " + _toDisplayString(_unref(t)('payrolls.changes.confirm_2')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(AlertDialogDescription), { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('salary.js.confirm')), 1)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('salary.js.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                variant: "default",
                onClick: _unref(mutate)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('salary.js.yes')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})